export const FLAGS = {
    USE_MOCK_API: false,
    DEBUG_LOGS: true,
    RELAX_DERIV_GATE: false,
    ENABLE_REJECT_FEATURE: true,
    FORCE_CLIENT_SPLASH: false
};
